<template>
  <div>
    <article v-for="d in data"> // v-for で props で指定した data を繰り返す
      <div v-for="p in d.picture" v-if="p.id === '1'"> // v-if で写真の一枚目のみ呼び出し
        <router-link :to="'/works/' + d.slug"><img :src="p.path"></router-link>
        // 詳細へのリンクと画像の URL
      </div>
      <div>
        <h3 v-cloak><router-link :to="'/works/' + d.slug">{{ d.title }}</router-link></h3>
        // 作品のタイトル
        <p class="product-description" v-cloak>{{ d.text }}</p> // 作品の詳しめ解説
        <p class="product-year" v-cloak> 制作年：{{ d.year }}</p> // 制作年
      </div>
    </article>
    30 31
  </div>
</template>

<script>
    export default {
        props: ['data'] // 追加
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/WorksTop.vue